<script lang="ts">
  export let active: boolean = false;
</script>

<div class:active>
  <div></div>
</div>

<style lang="postcss">
  div {
    @apply flex flex-row items-center justify-center w-[11px] h-[11px] rounded-full bg-light-100;
  }

  .active {
    @apply bg-primary-datadocs-blue;
  }

  .active > div {
    @apply bg-white;
    width: 5px;
    height: 5px;
  }
</style>
